<template>
  <div class="chart-card">
    <div class="flex flex-column">
      <div>
        <h1 class="f5 f4-l fw5 ma0 pa0 lh-title">
          {{ report.title }}
        </h1>
        <span class="db f6 f5-l ma0 pa0 lh-title text-secondary">
          {{ report.subtitle }}
        </span>
      </div>
    </div>

    <div class="flex flex-column">
      <div class="mt4">
        <svg-plot :config="report.plotConfig">
          <svg-h-stack :data="report.stack" />
          <svg-line v-if="report.line" :data="report.line" />
        </svg-plot>
      </div>

      <ul class="list pa0 ma0 mt4">
        <li v-for="(leg, index) in report.legend" :key="index" class="f6 flex items-center">
          <span class="square ma2" :style="'background-color: ' + leg.color + ';'"></span>{{ leg.label }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import SvgPlot from '@/components/charts/svg/plot/Plot.vue'
import SvgLine from '@/components/charts/svg/plot/Line.vue'
import SvgHStack from '@/components/charts/svg/plot/HStack.vue'

export default {
  props: ['report'],
  components: {
    SvgPlot,
    SvgLine,
    SvgHStack
  }
}
</script>

<style lang="scss" scoped>
.chart-card {
  display: flex;
  flex-direction: column;
  justify-items: center;
  padding: 1.5rem 1.5rem 1.5rem 1.5rem;
  background-color: #FFFFFF;
  border-radius: .25rem;
  min-width: 270px;
  max-width: 350px;
}
.legend-line {
  width: 100%;
  height: 0;
  border-top-left-radius: 20%;
  border-bottom-left-radius: 20%;
  border-top: 2px solid transparent;
  border-bottom: 2px solid transparent;
  border-left-style: solid;
  border-left-width: 270px;
  overflow: hidden;
}
@media screen and (min-width: 60em) {
  .legend-line {
    width: 100%;
    height: 0;
    border-top-left-radius: 20%;
    border-bottom-left-radius: 20%;
    border-top: 2px solid transparent;
    border-bottom: 2px solid transparent;
    border-left-style: solid;
    border-left-width: 270px;
    overflow: hidden;
  }
}
</style>
